import React from 'react';

import HighlightedText from '@marketing/components/highlighted_text';

import WallOfLoveSection from '../../../sections/wall_of_love';

import DestinyHeadshot from './assets/destiny_headshot.png';

export default (props) => {
  return (
    <WallOfLoveSection
      featuredQuote={{
        studentName: 'Destiny L.',
        studentAffiliation: null,
        content: (
          <>
            "Magoosh helped me sharpen my skills and get <HighlightedText color="#FCF0BF">thoroughly prepared </HighlightedText> for the test. The video content, including the <HighlightedText color="#FCF0BF">explanations</HighlightedText>, helped enhance my understanding of individual topics and the test as a whole. The almost unlimited <HighlightedText color="#FCF0BF">practice questions</HighlightedText> and subsequent <HighlightedText color="#FCF0BF">analysis</HighlightedText> helped me pinpoint my weak points and work on them. The entire process of preparing with Magoosh is so systematic and <HighlightedText color="#FCF0BF">convenient</HighlightedText> that it takes away all the stress."
          </>
        ),
        image: {
          height: '300px',
          src: DestinyHeadshot,
          width: '340px'
        }
      }}
      quotes={[
        {
          studentName: 'Karen G.',
          studentAffiliation: null,
          content: (
            <>
              "I'm beyond thankful that Magoosh helped me get into my <HighlightedText color="#FCF0BF">dream school</HighlightedText>.  The video lessons and explanations really helped me grasp the concepts and <HighlightedText color="#FCF0BF">master my mistakes.</HighlightedText>"
            </>
          )
        },
        {
          studentName: 'Amber J.',
          studentAffiliation: null,
          content: (
            <>
              "It gave me <HighlightedText color="#FCF0BF">peace of mind</HighlightedText> that if my daughter followed the <HighlightedText color="#FCF0BF">schedule</HighlightedText>, she'd be prepared in a way I could never have prepared her for! "
            </>
          )
        },
        {
          studentName: 'Steven T.',
          studentAffiliation: null,
          content: (
            <>
              "I'm a fan of how it teaches me. It's quite <HighlightedText color="#FCF0BF">easy to use</HighlightedText>, great note taking section area, and a <HighlightedText color="#FCF0BF">lot of strategies</HighlightedText> and ways to excel."
            </>
          )
        },
        {
          studentName: 'Gabby W.',
          studentAffiliation: null,
          content: (
            <>
              "Magoosh helped me learn the material better, actually understand what I was doing, and <HighlightedText color="#FCF0BF">build confidence</HighlightedText> in what I know."
            </>
          )
        }
      ]}
    />
  );
};
